export const ROUTES = {
	HOME: '/',
	LOGIN: '/sign-in',
	SIGNUP: '/sign-up',
	RESET_PASSWORD: '/reset-password',
	CREATE_NEW_PASSWORD: '/reset-password/new',
	PAYMENT_SUCCESS: '/payment-success',
	PAYMENT_CANCEL: '/payment-cancel',
	METHOD_SUCCESS: '/method-success',
	METHOD_CANCEL: '/method-cancel',
};
